// Feature-Flags (F2/#35, Welle 2): kleiner Client-Cache über GET /api/config/features,
// damit nicht jede Komponente die Flags einzeln lädt. Fällt bei Fehlern auf
// "alles aktiv" zurück — die Server-Routen prüfen die Flags ohnehin verbindlich.
import { useEffect, useState } from 'react';
import apiService from '../services/apiService';

const TTL_MS = 60 * 1000;
const DEFAULTS = { searchAi: true, summaryAi: true, customers: true };

let cached = null;
let cachedAt = 0;
let pending = null;

export async function getFeatures() {
  const now = Date.now();
  if (cached && (now - cachedAt) < TTL_MS) return cached;
  if (pending) return pending;
  pending = (async () => {
    try {
      const resp = await apiService.getFeatures();
      cached = { ...DEFAULTS, ...((resp && resp.features) || {}) };
      cachedAt = Date.now();
      return cached;
    } catch (_) {
      return cached || DEFAULTS;
    } finally {
      pending = null;
    }
  })();
  return pending;
}

// Ein Flag als Hook (#251): startet mit dem zwischengespeicherten Wert bzw. dem
// Standard und zieht nach dem ersten Laden nach. Für Anzeigen, die sich nach
// einem Schalter richten -- verbindlich prüft weiterhin der Server.
export function useFeature(name) {
  const [aktiv, setAktiv] = useState(() => (cached ? cached[name] !== false : DEFAULTS[name] !== false));
  useEffect(() => {
    let abgebrochen = false;
    getFeatures().then(f => { if (!abgebrochen) setAktiv(f[name] !== false); });
    return () => { abgebrochen = true; };
  }, [name]);
  return aktiv;
}

export function invalidateFeaturesCache() {
  cached = null;
  cachedAt = 0;
}
